export function isExist(value, list, key = 'Name') {
  return list.some((files) => files[key].toLowerCase() === value.toLowerCase());
}

export function isContainSymbol(value) {
  const stringRegex = /[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/;
  return stringRegex.test(value);
}
